
export const ScoreboardType = {
  SCHOOL: 'school',     
  STUDENTS: 'students',  
  CLASSES: 'classes', 
};

export const SchoolType = {
  STATE: 'state',
  STATE_RELIGIOUS: 'stateReligious',
  SMALL_SCHOOLS: 'smallSchools',
  GENERAL_SCHOOLS: 'generalSchools',
  CHAREDI_GENERAL_SCHOOLS: 'charediGeneralSchools',
  CHAREDI_SMALL_SCHOOLS: 'charediSmallSchools',
  JERUSALEM_DISTRICT: 'jerusalemDistrict',
  SOUTH_DISTRICT: 'southDistrict',
  TEL_AVIV_DISTRICT: 'telAvivDistrict',
  CENTER_DISTRICT: 'centerDistrict',
  HAIFA_DISTRICT: 'haifaDistrict',
  NORTH_DISTRICT: 'northDistrict',
  SETTLEMENT_EDUCATION_DISTRICT: 'settlementEducationDistrict',
  JERUSALEM_CITY_DISTRICT: 'jerusalemCityDistrict',
  CHAREDI_DISTRICT: 'charediDistrict',
};

